<template>
    <div v-if="isAvailable">
        <b-btn class="btn-card-action my-1" @click="preProlong">Продлить закупочную сессию до {{ getDateTimeFormat(purchase.flags.max_prolong_datetime) }}</b-btn>
        <b-modal ref="delete-modal" v-model="isModalVisible" centered hide-header-close no-close-on-backdrop no-close-on-esc title="Продлить закупочную сессию">
            <div class="d-block text-left">Вы действительно хотите продлить закупочную сессию {{ purchase.purchase_info.reg_number }} до {{ getDateTimeFormat(purchase.flags.max_prolong_datetime) }}?</div>
            <div slot="modal-footer" class="w-100 text-right">
                <b-overlay :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button class="text-uppercase mr-2" variant="custom-outline-secondary" @click="cancelModal">Отмена</b-button>
                </b-overlay>
                <b-overlay :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button class="text-uppercase" variant="custom-green" @click="prolongPurchase">Продлить</b-button>
                </b-overlay>
            </div>
        </b-modal>
    </div>
</template>

<script>
import debounceMixin from '@/mixins/debounce';

export default {
    name: 'cabinet-fl44-notice-card-prolong-button',
    props: {
        purchase: {
            type: Object,
            required: true
        }
    },
    mixins: [debounceMixin],
    data() {
        return {
            isModalVisible: false,
            isDataSending: false,
            isLoading: false
        };
    },
    methods: {
        showModal() {
            this.isModalVisible = true;
        },
        cancelModal() {
            this.isModalVisible = false;
        },
        preProlong() {
            this.isModalVisible = true;
        },
        async prolongPurchase() {
            this.isDataSending = true;
            if (await this.$api.personal[this.purchase.type === 'fl44' ? 'fl44' : 'fl44UnknownVolume'].prolongPurchase(this.purchase.id)) {
                this.cancelModal();
                this.$emit('action');
            }
            this.isDataSending = false;
        }
    },
    computed: {
        isAvailable() {
            return this.purchase.actions.prolong;
        }
    }
};
</script>
